import React, {FC} from "react"
import {H3} from "@irati/ui/src/Typography"
import {DealCategory} from "@irati/types"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Selector from "@irati/ui/src/Selector"
import {CategoryWrapper, SelectorWrapper} from "./styled"

interface Props extends InjectIntl {
  category: DealCategory,
  toggleSelection: (id: string, name: string) => void,
  selection: string[]
}

const CustomisationCategory: FC<Props> = ({category, toggleSelection, selection, formatMessage}) => {
  const {name, tags = [], uuid} = category
  const activeTags = tags.filter(({filterable}) => filterable === true)
  const categoryHasTags = activeTags && activeTags.length > 0

  return (
    <CategoryWrapper>
      <H3>{name}</H3>
      <SelectorWrapper>
        {categoryHasTags &&
          activeTags.map((tag) => (
            <Selector key={tag.uuid} name={tag.name} uuid={tag.uuid} onClick={toggleSelection} selected={selection.includes(tag.uuid)} />
          ))}
        {!categoryHasTags && (
          <Selector
            key={uuid}
            name={formatMessage(
              {
                id: "account.customisation.interests.allLabel"
              },
              {
                name
              }
            )}
            uuid={uuid}
            onClick={toggleSelection}
            selected={selection.includes(uuid)} />
        )}
      </SelectorWrapper>
    </CategoryWrapper>
  )
}

export default injectIntl(CustomisationCategory)
